import React from 'react';
export function Footer() {
  return <footer className="bg-[#1B5E20] text-white py-12" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-62">
          <div data-id="element-63">
            <div className="flex items-center space-x-2 mb-4" data-id="element-64">
              <img src="https://cdn.magicpatterns.com/uploads/wvCpgEAasUkNkK1QxxXNi9/LymphoriaX_(1).png" alt="LymphoriaX Logo" className="h-8" data-id="element-65" />
            </div>
            <p className="text-gray-300 max-w-sm" data-id="element-66">
              Premium herbal support for lymphatic drainage, energy, and
              vitality. Trusted by 12,847+ women.
            </p>
          </div>
          <div className="flex flex-col md:items-end justify-center" data-id="element-67">
            <div className="space-x-6 text-gray-300 text-sm" data-id="element-68">
              <a href="#" className="hover:text-[#10B981] transition-colors" data-id="element-69">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-[#10B981] transition-colors" data-id="element-70">
                Terms of Service
              </a>
              <a href="#" className="hover:text-[#10B981] transition-colors" data-id="element-71">
                Contact Us
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#10B981]/30 pt-8 text-center md:text-left" data-id="element-72">
          <p className="text-xs text-gray-400 leading-relaxed max-w-4xl" data-id="element-73">
            * These statements have not been evaluated by the FDA. This product
            is not intended to diagnose, treat, cure, or prevent any disease.
            Results may vary. The information provided does not constitute
            medical advice and should not take the place of consulting a
            physician. This information does not and should not replace
            treatment from a medical professional.
          </p>
          <p className="text-xs text-gray-400 mt-4" data-id="element-74">
            © {new Date().getFullYear()} LymphoriaX. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}